'use client'

import { ErrorPage } from '@/modules/app/error-page'
import { useEffect } from 'react'
import posthog from 'posthog-js'

/**
 * https://nextjs.org/docs/app/building-your-application/routing/error-handling#handling-global-errors
 */
export default function GlobalError({
  error,
}: {
  error: Error & { digest?: string }
}) {
  useEffect(() => {
    posthog.captureException('global-error', {
      errorMessage: error.message,
      errorCause: error.cause,
      errorStack: error.stack,
      errorName: error.name,
      errorDigest: error.digest,
    })
    console.warn('[POSTHOG_DETECTION_ID]:global-error', error)
  }, [error])

  return <ErrorPage />
}
